import { useLocalSearchParams } from "expo-router";
import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import PairPage from "$src/core/pages/PairPage/PairPage";

type Params = {
  code?: string;
};

const Route: React.FC = () => {
  const { code } = useLocalSearchParams<Params>();

  return (
    <PageLayout>
      <PairPage code={code} />
    </PageLayout>
  );
};

export default Route;
